// Multi-column sort state — mirrors invoice_reports table types but owned independently
export interface MultiColumnSortState {
  columnKey: string;
  order: 'ascend' | 'descend';
}

// Raw state from Table component (order can be null when sort is cleared)
export interface SortOrderState {
  columnKey?: string;
  order?: 'ascend' | 'descend' | null;
}

export const isValidSortState = (
  state: SortOrderState
): state is MultiColumnSortState => {
  return (
    typeof state.columnKey === 'string' &&
    state.columnKey !== '' &&
    (state.order === 'ascend' || state.order === 'descend')
  );
};
